export default __webpack_public_path__ + "static/media/wallcrack.d76ef65d.png";